// src/features/dashboard/utils/formatters.ts

const numberFormatter = new Intl.NumberFormat('fa-IR');
const compactFormatter = new Intl.NumberFormat('fa-IR', { notation: 'compact' });

export function formatNumber(value: number): string {
  return numberFormatter.format(value);
}

export function formatCompactNumber(value: number): string {
  return compactFormatter.format(value);
}

export function formatToman(value: number): string {
  return `${numberFormatter.format(value)} تومان`;
}

export function formatCompactToman(value: number): string {
  return `${compactFormatter.format(value)} تومان`;
}

export function formatStatValue(value: number, format: 'number' | 'currency' | 'percent'): string {
  switch (format) {
    case 'currency':
      return formatToman(value);
    case 'percent':
      return `${numberFormatter.format(value)}٪`;
    case 'number':
    default:
      return formatNumber(value);
  }
}
